module.exports = __webpack_public_path__ + "static/img/portalBg.5a05345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portalBg.png
// module id = ucSM
// module chunks = 2